import { getAnalytics, logEvent } from 'firebase/analytics';

export const FirebaseMenuClick = () => {
  const analytics = getAnalytics();
  logEvent(analytics, 'home_menu_frequency_click', {
    button_type: 'main_menu',
  });
};
